const Constants = {
  MANAGER: 'MANAGER',
  AGENT: 'AGENT',
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN'
};

export default Constants;
